import { Button, DropdownMenu } from '@octopus-do/octopus-storybook'
import { AngleDown } from '@octopus-do/octopus-storybook/icons'
import { selectIsLoading } from '@store/loaders'
import React from 'react'
import { useSelector } from 'react-redux'

export const DownloadButton = React.forwardRef<HTMLButtonElement>((_, ref) => {
  const loading = useSelector(selectIsLoading('report_export_pdf'))
  const { active, toggle } = DropdownMenu.useTrigger()

  return (
    <Button
      ref={ref}
      size="medium"
      label="Download"
      right={AngleDown}
      loading={loading}
      active={active}
      onPointerDown={toggle}
    />
  )
})
